import type {
  GetListingsV2CountQuery,
  GetListingsV2Query,
} from '~/api/listings/types'

export const listingCountParamsTransformer = (
  params: GetListingsV2Query,
): GetListingsV2CountQuery => {
  const { cursorId, direction, pageSize, orderBy, ...rest } = params

  return {
    ...rest,
  }
}
